import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface Inspection {
  id: number
  branchCodes: {
    from: string
    to: string
    not: boolean
  }[]
  collectionTypes: {
    from: string
    to: string
    not: boolean
  }[]
  shelfTypes: {
    from: string
    to: string
    not: boolean
  }[]
  status: SystemCode
  requestId: number
  jobRequestId: number | null
  revision: number
}

export const defaultInspection = (): Inspection => ({
  id: 0,
  branchCodes: [],
  collectionTypes: [],
  shelfTypes: [],
  status: defaultSystemCode(),
  requestId: 0,
  jobRequestId: null,
  revision: 0
})

export function InspectionFromJSON(json: any): Inspection {
  return {
    id: exists(json, 'id') ? json.id : 0,
    branchCodes: exists(json, 'branch_codes')
      ? json.branch_codes.map((value: any) => {
          return {
            from: exists(value, 'from') ? value.from : '',
            to: exists(value, 'to') ? value.to : '',
            not: exists(value, 'not') ? value.not : false
          }
        })
      : [],
    collectionTypes: exists(json, 'collection_types')
      ? json.collection_types.map((value: any) => {
          return {
            from: exists(value, 'from') ? value.from : '',
            to: exists(value, 'to') ? value.to : '',
            not: exists(value, 'not') ? value.not : false
          }
        })
      : [],
    shelfTypes: exists(json, 'shelf_types')
      ? json.shelf_types.map((value: any) => {
          return {
            from: exists(value, 'from') ? value.from : '',
            to: exists(value, 'to') ? value.to : '',
            not: exists(value, 'not') ? value.not : false
          }
        })
      : [],
    status: exists(json, 'status')
      ? SystemCodeFromJSON(json.status)
      : defaultSystemCode(),
    requestId: exists(json, 'request_id') ? json.request_id : 0,
    jobRequestId: exists(json, 'job_request_id') ? json.job_request_id : null,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
